module.exports = __webpack_public_path__ + "static/media/category-4.686e7566.png";